<!-- Hand is position:fixed against viewport coords from getBoundingClientRect(), so it
     stays aligned inside sticky/scrolling layouts. -->
<img
  *ngIf="pointerVisible && handOnScreen"
  src="assets/Images/hand-pointer.png"
  alt=""
  class="draw-hand"
  [class.draw-hand--official]="isOfficial"
  [class.draw-hand--tracking]="handTracking"
  [class.draw-hand--press]="buttonClick"
  [style.left.px]="handPosition.left"
  [style.top.px]="handPosition.top">

<section
  class="draw-panel"
  #panel
  *ngIf="copy"
  [class.draw-panel--official]="isOfficial"
  [class.draw-panel--calibration]="!isOfficial">

  <header class="draw-head">
    <p class="draw-kicker">
      <span class="draw-kicker-dot" aria-hidden="true"></span>{{ copy.kicker }}
    </p>
    <h2 class="draw-title">{{ copy.title }}</h2>
    <p class="draw-note" *ngIf="copy.note">{{ copy.note }}</p>

    <div class="draw-steps" *ngIf="!isOfficial" aria-hidden="true">
      <span
        class="draw-step"
        *ngFor="let step of [1, 2, 3]"
        [class.is-done]="step < calibrationStep"
        [class.is-live]="step === calibrationStep"></span>
    </div>
  </header>

  <div class="draw-range">
    <div class="draw-card" #minCard [class.is-active]="pointerAt === 'min'">
      <span class="draw-card-label">Min</span>
      <span class="draw-card-value">{{ min == null ? '—' : min }}</span>
    </div>
    <div class="draw-range-sep" aria-hidden="true">→</div>
    <div class="draw-card" #maxCard [class.is-active]="pointerAt === 'max'">
      <span class="draw-card-label">Max</span>
      <span class="draw-card-value">{{ max == null ? '—' : max }}</span>
    </div>
  </div>

  <!-- Deliberately not a <button>: it is a replica of the operator's control, never
       clickable, and global button styles would fight the panel theme. -->
  <div
    class="draw-generate"
    aria-hidden="true"
    #generateButton
    [class.is-active]="pointerAt === 'button'"
    [class.is-pressed]="buttonClick">
    <span class="draw-generate-label">Generate</span>
    <span class="draw-generate-ripple" *ngIf="buttonClick"></span>
  </div>

  <div class="draw-result-block">
    <p class="draw-result-caption">{{ isOfficial ? 'Winning seat' : 'Test output' }}</p>
    <div
      class="draw-result"
      #resultCard
      [class.is-active]="pointerAt === 'result'"
      [class.is-rolling]="resultRolling"
      [class.is-landed]="resultLanded">
      <span class="draw-result-value">{{ result || '—' }}</span>
    </div>
    <p class="draw-winner" *ngIf="isOfficial && displayUserName">{{ displayUserName }}</p>
    <p class="draw-status" *ngIf="roundComplete && !isOfficial">System check passed</p>
  </div>

  <p class="draw-disclaimer" *ngIf="!isOfficial">
    System check numbers come from the machine's full range and are not linked to any seat.
    No prize is awarded on these rounds.
  </p>
</section>
